<template>
  <section class="content">
    <div id="bg" class="bg" />
    <header>
      <h1>Photos by Color</h1>
      <p class="subTitle">
        uploaded in May 2019 organized by colors
      </p>
    </header>
    <ColorCanvasViz />
    <aside>
      <h2>About this visualization</h2>
      <p>Images organized by colors and color palettes: while it may sound unusual, it shows us a somewhat surprising result, which also depends on the color analyzer used.</p>
      <p>The first image analyzer, <i>imgix</i> is used by Unsplash to determine a placeholder color for each image that is displayed in your web browser until the image is downloaded.</p>
      <p>Running the same image analysis with a different tool shows how difficult it is for an algorithm to extract <i>THE</i> main color of an image. Click on the button "Image Palette" to switch the image analyzer.</p>
      <p>Click on any dot to see the preview of the image, and you can also the color palette.</p>
      <p>Clicking on the view button of the preview will load the image in the background. Use your mouse wheel to zoom in and out of the graphic and move it to the side to enjoy the image.</p>
    </aside>
  </section>
</template>

<script>
// @ is an alias to /src
import ColorCanvasViz from "@/components/colorcanvasviz.vue"

export default {
    name: "ColorCanvasPage",
    components: {
        ColorCanvasViz
    }
}
</script>

<style lang="stylus">
.content {
  
}
</style> 


